import { Box } from '@mui/system';
import { Badge, badgeStyle, badgeType, Button, IconButton, Text } from '../../../../../packages';
import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import { EVALUATION_STATUS } from '../../../../../constants/CommonConstants';
import history from '../../../../../utils/history';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useStyles } from './index.styles';
import EvaluationDetails from './EvaluationDetails';

const EvaluationDetail = ({
  isOpen,
  onClose,
  evaluation,
  isView = true,
  appointmentId,
  memberId,
  fullScreen,
}) => {
  const classes = useStyles();

  const renderContent = () => (
    <EvaluationDetails
      fullScreen={fullScreen}
      evaluation={evaluation}
      appointmentId={appointmentId}
      memberId={memberId}
    />
  );

  const statusBadgeStyle =
    evaluation?.aiCompletionStatus === 'IN_PROGRESS'
      ? badgeStyle.MISREPORTED
      : evaluation.status === 'NOT_STARTED'
      ? badgeStyle.INACTIVE
      : evaluation.status === 'IN_PROGRESS'
      ? badgeStyle.PRIMARY
      : evaluation.status === 'REJECTED'
      ? badgeStyle.CRITICAL
      : badgeStyle.SUCCESS;

  const renderStatusBadge = () => {
    if (evaluation?.aiCompletionStatus === 'IN_PROGRESS') return 'Waiting for AI';
    return EVALUATION_STATUS[evaluation.status];
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      variant={drawerType.NORMAL}
      className={clsx(classes.drawer, fullScreen && classes.fullScreen)}
    >
      <Box className={classes.wrapper}>
        <Box className={classes.header}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <IconButton icon="chevron-left" onClick={onClose} className={classes.backBtn} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Text className={classes.title}>{evaluation.name}</Text>
                <Badge style={statusBadgeStyle} variant={badgeType.OUTLINED} className={classes.evBadge}>
                  {renderStatusBadge()}
                </Badge>
              </Box>
              {fullScreen && (
                <Box display="flex" justifyContent="flex-start" width="100%">
                  <Text className={classes.subTitle}>
                    Completed {dayjs(evaluation?.completedAt || '').format('MM/DD/YYYY')}
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
          {isView && (
            <Button
              className={classes.editEvaluationDetail}
              onClick={() =>
                history.push(`/admin/collection-evaluations-states/${evaluation.id}/${appointmentId}`)
              }
            >
              Edit
            </Button>
          )}
        </Box>
        {renderContent()}
      </Box>
    </Drawer>
  );
};

export default EvaluationDetail;
